import * as AccountDialog from './../../components/Dialog/AccountDialog';

import { COUNT_PER_PAGE, YN } from '../../constants/Constants';
import React, { useEffect, useState } from 'react';
import {
  columnDateTime,
  columnEnterpriseType,
  columnUseYn,
} from '../../utils/dataTableUtil';

import { CodeUtil } from '../../utils/CodeUtil';
import { Column } from 'primereact/column';
import { CommonUtil } from '../../utils/commonUtil';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { MyInfoUtil } from '../../utils/myInfoUtil';
import { Panel } from 'primereact/panel';
import { ProgressBar } from 'primereact/progressbar';
import { RadioButton } from 'primereact/radiobutton';
import SearchMenu from '../../components/Menu/SearchMenu';
import ServiceMenu from '../../components/Menu/ServiceMenu';
import { ServiceProvider } from '../../services';
import _ from 'lodash';
import { myInfoSelector } from '../../recoil/selectors';
import { useAuthorizedFetch } from '../../hooks/useAuthorizedFetch';
import { useRecoilValueLoadable } from 'recoil';

const DEFAULT_SEARCH_CONDITIONS = {
  associations: [],
  enterpriseType: '',
  searchType: 'C',
  searchText: '',
  useYN: 'Y',
};
const DEFAULT_LAZY_PARAMS = {
  first: 0,
  rows: 10,
  page: 0,
};

const enterpriseService = ServiceProvider.enterprise;

const EnterpriseList = () => {
  const myInfoLoadable = useRecoilValueLoadable(myInfoSelector);

  const [searchConditions, setSearchConditions] = useState({
    ...DEFAULT_SEARCH_CONDITIONS,
  });
  const [lazyParams, setLazyParams] = useState({ ...DEFAULT_LAZY_PARAMS });

  const { loading, totalRecords, data, getList, initList } = useAuthorizedFetch(
    enterpriseService,
    searchConditions,
    setSearchConditions,
    DEFAULT_SEARCH_CONDITIONS,
    lazyParams.page,
    lazyParams.rows
  );

  const [codes, setCodes] = useState({});
  const [currentEnterpriseId, setCurrentEnterpriseId] = useState(null);

  function handleSelectAll(
    selected,
    field,
    updateCodes,
    updateSearchConditions
  ) {
    const update = [];

    if (selected && selected.includes('')) {
      update.push(
        ..._.get(codes, `${field}`).map((option) => {
          if (option.value !== '') {
            option.disabled = true;
          }
          return option;
        })
      );

      setCodes((ps) => ({ ...ps, [field]: update, ...updateCodes }));
      setSearchConditions((ps) => ({
        ...ps,
        [field]: [_.get(codes[field], '0.value')],
        ...updateSearchConditions,
      }));
      return;
    }

    update.push(
      ..._.get(codes, `${field}`).map((option) => {
        if (option.disabled) delete option.disabled;
        return option;
      })
    );

    setCodes((ps) => ({ ...ps, [field]: update, ...updateCodes }));

    if (selected === null) {
      setSearchConditions((ps) => ({ ...ps, [field]: '' }));
      return;
    }

    setSearchConditions((ps) => ({
      ...ps,
      [field]: selected,
      ...updateSearchConditions,
    }));
  }

  useEffect(() => {
    (async () => {
      if (myInfoLoadable.state === 'hasValue') {
        const myInfo = MyInfoUtil.unpack(myInfoLoadable.contents);
        const [associations, associationId] =
          await CodeUtil.getAssociationCodes(myInfo, {
            preSelectedAssociationId: _.get(myInfo, 'myAssociationId'),
          });

        setCodes((ps) => ({ ...ps, associations }));

        await getList({ ...searchConditions, associations: [associationId] });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myInfoLoadable.state]);

  return (
    <div className="grid">
      <div className="col-12">
        {(() => {
          switch (myInfoLoadable.state) {
            case 'hasValue':
              return (
                <>
                  <SearchMenu
                    onInit={() => initList()}
                    onSearch={() =>
                      getList(
                        searchConditions,
                        _.get(DEFAULT_LAZY_PARAMS, 'page'),
                        _.get(DEFAULT_LAZY_PARAMS, 'rows')
                      )
                    }
                  >
                    <div className="field col-12 sm:col-6 lg:col-3">
                      <label htmlFor="range">소속협회</label>
                      <MultiSelect
                        className="w-full"
                        options={codes.associations}
                        display="chip"
                        placeholder="전체 협회"
                        value={searchConditions.associations}
                        filter
                        showSelectAll={false}
                        onChange={({ value }) => {
                          handleSelectAll(value, 'associations');
                        }}
                      />
                    </div>
                    <div className="field col-12 sm:col-6 lg:col-3">
                      <label htmlFor="range">점검법인구분</label>
                      <div className="flex flex-auto flex-wrap align-items-center justify-content-start mt-2 gap-3">
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_enterpriseType_all"
                            name="enterpriseType"
                            value=""
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                enterpriseType: value,
                              }));
                            }}
                            checked={searchConditions.enterpriseType === ''}
                          />
                          <label htmlFor="radio_enterpriseType_all">전체</label>
                        </div>
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_enterpriseType_direct"
                            name="enterpriseType"
                            value="AD"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                enterpriseType: value,
                              }));
                            }}
                            checked={searchConditions.enterpriseType === 'AD'}
                          />
                          <label htmlFor="radio_enterpriseType_direct">
                            협회직영
                          </label>
                        </div>
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_enterpriseType_franchise"
                            name="enterpriseType"
                            value="FR"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                enterpriseType: value,
                              }));
                            }}
                            checked={searchConditions.enterpriseType === 'FR'}
                          />
                          <label htmlFor="radio_enterpriseType_franchise">
                            프랜차이즈(법인)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="field col-12 sm:col-6 lg:col-3">
                      <label htmlFor="range">점검업체</label>
                      <InputText
                        className="w-full"
                        value={searchConditions.searchText}
                        placeholder={
                          searchConditions.searchType === 'C'
                            ? '점검업체 코드, 점검업체명으로 검색'
                            : '담당자 이름, 연락처로 검색'
                        }
                        onChange={({ target: { value } }) => {
                          setSearchConditions((ps) => ({
                            ...ps,
                            searchText: value,
                          }));
                        }}
                      />
                      <div className="flex flex-auto flex-wrap align-items-center justify-content-start mt-2 gap-3">
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_searchType_enterprise"
                            name="searchType"
                            value="C"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                searchType: value,
                              }));
                            }}
                            checked={searchConditions.searchType === 'C'}
                          />
                          <label htmlFor="radio_searchType_enterprise">
                            점검업체
                          </label>
                        </div>
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_searchType_person"
                            name="searchType"
                            value="P"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                searchType: value,
                              }));
                            }}
                            checked={searchConditions.searchType === 'P'}
                          />
                          <label htmlFor="radio_searchType_person">
                            담당자
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="field col-12 sm:col-6 lg:col-3">
                      <label htmlFor="range">사용여부</label>
                      <div className="flex flex-auto flex-wrap align-items-center justify-content-start mt-2 gap-3">
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_useYN_all"
                            name="useYN"
                            value=""
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                useYN: value,
                              }));
                            }}
                            checked={searchConditions.useYN === ''}
                          />
                          <label htmlFor="radio_useYN_all">전체</label>
                        </div>
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_useYN_y"
                            name="useYN"
                            value="Y"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                useYN: value,
                              }));
                            }}
                            checked={searchConditions.useYN === YN.YES}
                          />
                          <label htmlFor="radio_useYN_y">사용</label>
                        </div>
                        <div className="flex flex-auto flex-grow-0 flex-shrink-0 align-items-center justify-content-start gap-1">
                          <RadioButton
                            inputId="radio_useYN_n"
                            name="useYN"
                            value="N"
                            onChange={({ value }) => {
                              setSearchConditions((ps) => ({
                                ...ps,
                                useYN: value,
                              }));
                            }}
                            checked={searchConditions.useYN === YN.NO}
                          />
                          <label htmlFor="radio_useYN_n">미사용</label>
                        </div>
                      </div>
                    </div>
                  </SearchMenu>

                  <ServiceMenu
                    title={'점검업체'}
                    onClickRegisterBtn={() => setCurrentEnterpriseId(0)}
                    excelData={{
                      type: 'enterprise',
                      params: {
                        ...searchConditions,
                        page: lazyParams.page + 1,
                        size: lazyParams.rows,
                      },
                    }}
                    buttonVisible={CommonUtil.Func.checkAuth(
                      myInfoLoadable.contents,
                      'ADMIN'
                    )}
                  />

                  <Panel className="shadow-1 mb-3">
                    <DataTable
                      value={data}
                      lazy
                      rows={lazyParams.rows}
                      first={lazyParams.first}
                      totalRecords={totalRecords}
                      onPage={async (event) => {
                        setLazyParams(event);
                        await getList(searchConditions, event.page, event.rows);
                      }}
                      paginator
                      responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="전체 {totalRecords}건 중 {first} ~ {last}"
                      rowsPerPageOptions={COUNT_PER_PAGE}
                      resizableColumns
                      showGridlines
                      loading={loading}
                      emptyMessage="데이터가 없습니다."
                    >
                      <Column
                        header="순번"
                        body={(rowData, column) => (
                          <span>{column.rowIndex + 1}</span>
                        )}
                      />
                      <Column
                        field="enterpriseCode"
                        header={
                          <span>
                            점검업체
                            <br />
                            점검업체코드
                          </span>
                        }
                        body={({
                          enterpriseId,
                          enterpriseName,
                          enterpriseCode,
                        }) => (
                          <>
                            <span
                              className="text-primary cursor-pointer"
                              onClick={() =>
                                setCurrentEnterpriseId(enterpriseId)
                              }
                            >
                              {enterpriseName}
                            </span>
                            <br />[{enterpriseCode}]
                          </>
                        )}
                      />
                      <Column
                        field="enterpriseType"
                        header="업체구분"
                        body={({ enterpriseType }) =>
                          columnEnterpriseType(enterpriseType)
                        }
                      />
                      <Column
                        field="associationCode"
                        header="소속협회"
                        body={({ associationName, associationCode }) => (
                          <span>
                            {associationName}
                            {associationCode && (
                              <>
                                <br />[{associationCode}]
                              </>
                            )}
                          </span>
                        )}
                      />
                      <Column
                        field="shopCount"
                        header={
                          <div>
                            <span>소속점검장수</span>
                            <br />
                            <span>소속사용자수</span>
                          </div>
                        }
                        bodyClassName="text-right"
                        body={({ shopCount, userCount }) => (
                          <div>
                            <span>{shopCount ? shopCount + '개' : '없음'}</span>
                            <br />
                            <span>{userCount ? userCount + '명' : '없음'}</span>
                          </div>
                        )}
                      />
                      <Column
                        field="businessRegistrationNumber"
                        header="사업자등록번호"
                        body={({ businessRegistrationNumber }) => (
                          <span>
                            {businessRegistrationNumber &&
                              CommonUtil.Formatter.biz(
                                businessRegistrationNumber
                              )}
                          </span>
                        )}
                      />
                      <Column
                        field="businessRegistrationNumber"
                        header={
                          <div>
                            <span>대표전화</span>
                            <br />
                            <span>팩스</span>
                          </div>
                        }
                        body={({ mainPhone, fax }) => (
                          <div>
                            <span>
                              {mainPhone &&
                                CommonUtil.Formatter.phone(mainPhone)}
                            </span>
                            <br />
                            <span>{fax && CommonUtil.Formatter.fax(fax)}</span>
                          </div>
                        )}
                      />
                      <Column
                        field="agentCode"
                        header={
                          <div>
                            <span>담당자명</span>
                            <br />
                            <span>담당자연락처</span>
                            <br />
                            <span>담당자이메일</span>
                          </div>
                        }
                        body={({ personInCharge, picContact, picEmail }) => (
                          <div>
                            <span>{personInCharge}</span>
                            <br />
                            <span>
                              {picContact &&
                                CommonUtil.Formatter.cellphone(picContact)}
                            </span>
                            <br />
                            <span>{picEmail}</span>
                          </div>
                        )}
                      />
                      <Column field="note" header="비고" />
                      <Column
                        field="useYn"
                        header="사용여부"
                        body={({ useYn }) => columnUseYn(useYn)}
                        bodyClassName="text-center"
                      />
                      <Column
                        field="regTime"
                        header={
                          <div>
                            <span>등록사용자</span>
                            <br />
                            <span>등록일시</span>
                          </div>
                        }
                        body={({ regTime, regByUserName }) => (
                          <div>
                            <span>{regByUserName}</span>
                            <br />
                            <span>{columnDateTime(regTime)}</span>
                          </div>
                        )}
                      />
                      <Column
                        field="modTime"
                        header={
                          <div>
                            <span>수정사용자</span>
                            <br />
                            <span>수정일시</span>
                          </div>
                        }
                        body={({ modTime, modByUserName }) => (
                          <div>
                            <span>{modByUserName}</span>
                            <br />
                            <span>{columnDateTime(modTime)}</span>
                          </div>
                        )}
                      />
                      <Column
                        field="delTime"
                        header={
                          <div>
                            <span>삭제사용자</span>
                            <br />
                            <span>삭제일시</span>
                          </div>
                        }
                        body={({ delTime, delByUserName }) => (
                          <div>
                            <span>{columnDateTime(delTime)}</span>
                            <br />
                            <span>{delByUserName}</span>
                          </div>
                        )}
                      />
                    </DataTable>
                  </Panel>

                  {currentEnterpriseId !== null && (
                    <AccountDialog.Enterprise
                      visible
                      userInfo={myInfoLoadable.contents}
                      enterpriseId={currentEnterpriseId}
                      onHide={async () => {
                        setCurrentEnterpriseId(null);
                        await getList(
                          searchConditions,
                          lazyParams.page,
                          lazyParams.rows
                        );
                      }}
                    />
                  )}
                </>
              );
            case 'loading':
              return <ProgressBar mode="indeterminate" />;

            case 'hasError':
              return null;

            default:
          }
        })()}
      </div>
    </div>
  );
};

const comparisonFn = (prevProps, nextProps) => {
  return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(EnterpriseList, comparisonFn);
